      var componentForm = {
        locality: "long_name",
        administrative_area_level_1: "long_name",
        administrative_area_level_2: "long_name",
        postal_code: "short_name",
        postal_code_prefix: "short_name",
        country: "short_name"
      };
    var searchStr;
    var autocomplete;
    var autocompletefooter;
    var autocompletefaq;
    var autocompletebanner;
    var autocompletedesigner;
    var autocompletebookconsult;
    var autocompleteshowroom;
    var autocompletemobilee;
    var postal_code_from_coordinates;
    var retval;


          function initAutocomplete() {
            // Create the autocomplete object, restricting the search to geographical
            // location types.
            var options = {
                types: ['geocode'], // @see https://developers.google.com/maps/documentation/javascript/supported_types#table3
                componentRestrictions: {country: "ca"},
                fields: ["address_components", "geometry"],
            };

            autocomplete = new google.maps.places.Autocomplete(
                /** @type {!HTMLInputElement} */(document.getElementById('autocomplete')),
                options);
            autocomplete.addListener('place_changed', fillInAddress);
            
            if( document.getElementById('autocompletefooter') ) {
                autocompletefooter = new google.maps.places.Autocomplete(
                /** @type {!HTMLInputElement} */(document.getElementById('autocompletefooter')),
                options);
                autocompletefooter.addListener('place_changed', fillInAddressFooter);
           
            }
            // For FAQ Page
            if( document.getElementById('autocompletefaq') ) {
                autocompletefaq = new google.maps.places.Autocomplete(
                /** @type {!HTMLInputElement} */(document.getElementById('autocompletefaq')),
                options);
                autocompletefaq.addListener('place_changed', function() { fillInAddressFinder('faq'); } );
           
            }
            // For Banner Image
            if( document.getElementById('autocompletebanner') ) {
                autocompletebanner = new google.maps.places.Autocomplete(
                /** @type {!HTMLInputElement} */(document.getElementById('autocompletebanner')),
                options);
                autocompletebanner.addListener('place_changed', function() { fillInAddressFinder('banner'); } );
           
            }
            // For Designer Page             
            if( document.getElementById('autocompletedesigner') ) {
                autocompletedesigner = new google.maps.places.Autocomplete(
                /** @type {!HTMLInputElement} */(document.getElementById('autocompletedesigner')),
                options);
                autocompletedesigner.addListener('place_changed', function() { fillInAddressFinder('designer'); } );
           
            }
            
            // For Book Consult Widget
            if( document.getElementById('autocompletebookconsult') ) {
                autocompletebookconsult = new google.maps.places.Autocomplete(
                /** @type {!HTMLInputElement} */(document.getElementById('autocompletebookconsult')),
                options);
                autocompletebookconsult.addListener('place_changed', function() { fillInAddressFinder('bookconsult'); } );
           
            }
            // For Showroom Banner
            if( document.getElementById('autocompleteshowroom') ) {
                autocompleteshowroom = new google.maps.places.Autocomplete(
                /** @type {!HTMLInputElement} */(document.getElementById('autocompleteshowroom')),
                options);
                autocompleteshowroom.addListener('place_changed', function() { fillInAddressFinder('showroom'); } );
           
            }

            // For Mobile Location Finder
            if( document.getElementById('autocompletemobilee') ) {
                autocompletemobilee = new google.maps.places.Autocomplete(
                /** @type {!HTMLInputElement} */(document.getElementById('autocompletemobilee')),
                options);
                autocompletemobilee.addListener('place_changed', function() { fillInAddressFinder('mobilee'); } );
           
            }

            // Initialize map for localized pages
            if(document.getElementById("mapCanvas")) {
               initMap(); 
            }

            /**
             * Autocomplete in header scrolls away. Fix by appending autocomplete container to header and fixing top
             */
            function fix_header_pac_container_element() {
                //get the first place autocomplete container, ".pac-container", which is the one that's in the header
                const pacContainer = document.querySelector('.pac-container');

                //if autocomplete is a header child, make sure pacContainer is also a header child, so it's position:fixed too
                const header = document.querySelector('header');
                if (header.querySelector('#autocomplete') && pacContainer && pacContainer.parentNode !== header) {
                    header.appendChild(pacContainer);
                    //top could be calculated from #autocomplete .offsetHeight + .offsetTop + .offsetParent.offsetTop ...
                    let style = document.createElement('style');
                    style.innerHTML = 'header .pac-container { top: 40px !important;}';
                    header.appendChild(style);

                }
            }

            //fix header's place autocomplete container on focus and on typing
            document.getElementById('autocomplete').addEventListener('focus', fix_header_pac_container_element);
            document.getElementById('autocomplete').addEventListener('input', fix_header_pac_container_element);
          }

      async function get_coordinates_from_search_string(search) {
          let geocoder = new google.maps.Geocoder();
          let response = await geocoder.geocode({
              componentRestrictions: { country: 'CA'},
              address: search
          });
          if (response.results[0]) {
              return response.results[0].geometry.location;
          }
          return null;
      }

      /**
       * Get (partial) postal code from coordinates. Partial postal code (3 chars) is enough for PHP finder class.
       */
      async function get_postal_code_from_coordinates(location) {
          // let latlng = {
          //     lat: place.geometry.location.lat(),
          //     lng: place.geometry.location.lng()
          // };

          let geocoder = new google.maps.Geocoder();



          const response = await geocoder.geocode({location: location});


          //cycle response.results. they go from most-to-least specific. usually the postal_code is in the first result
          for (let i = 0; i < response.results.length; i++) {
              var reverse_place = response.results[i];
              if (reverse_place.address_components) {
                  //find postal_code / postal_code_prefix
                  for (var t = 0; t < reverse_place.address_components.length; t++) {
                      //partial postal codes also have postal_code type. it's OK in this case
                      if (reverse_place.address_components[t].types[0] === 'postal_code') {
                          let postal_code = reverse_place.address_components[t].long_name;
                          return postal_code;
                      }
                  }
              }
          }

          // reverse_place = geocoder.geocode({ location: place.geometry.location })

      }
      async function createSearch(place) {

        var o = {};

        if (place.address_components) {
            //extract all components, along with their main type (locality, administrative_area_level_1, etc. when there are more than 1 type, usually the second is 'political')
            for (var t = 0; t < place.address_components.length; t++) {
                var a = place.address_components[t].types[0];
                componentForm[a] && (o[a] = place.address_components[t][componentForm[a]])
            }

            //if no postal code or postal code prefix is available, try to get a postal code from the coordinates.
            if (!o.postal_code && ! o.postal_code_prefix) {
                postal_code_from_coordinates = await get_postal_code_from_coordinates(place.geometry.location);
                if (postal_code_from_coordinates) {

                    if (postal_code_from_coordinates.length === 3) {
                        o.postal_code_prefix = postal_code_from_coordinates
                    } else {
                        o.postal_code = postal_code_from_coordinates
                    }
                }
            } else {
            }

            retval = o.postal_code ? o.postal_code : o.postal_code_prefix ? o.postal_code_prefix : o.locality ? o.locality + ", " + o.administrative_area_level_1 : o.administrative_area_level_2 ? o.administrative_area_level_2 + ", " + o.administrative_area_level_1 : o.administrative_area_level_1 + ", " + o.country


            return retval;

        }
        return ;

        //return place;
      }
      async function fillInAddress() {
        // Get the place details from the autocomplete object.
        var place = autocomplete.getPlace();

        // debugger;

        searchStr = await createSearch(place);
        
        jQuery('.lf-form').find("#finalResult").val(searchStr);
        jQuery('.lf-form').find(".lf-finder").click();

      }
      async function fillInAddressFooter() {
        // Get the place details from the autocomplete object.
        var place = autocompletefooter.getPlace();

        searchStr = await createSearch(place);
        
        //console.log(searchStr);
        jQuery('.lf-form-footer').find("#finalResultFooter").val(searchStr);
        jQuery('.lf-form-footer').find(".lf-finder-footer").click();

      }
      /********************************************************
      * Fill selected location and call finder function
      ********************************************************/
      async function fillInAddressFinder(idval) {
        // Get the place details from the autocomplete object.
       
        if(idval == 'banner') {
            var place = autocompletebanner.getPlace();
        } else if(idval == 'faq') {
            var place = autocompletefaq.getPlace();
        } else if(idval == 'designer') {
            var place = autocompletedesigner.getPlace();
        } else if(idval == 'bookconsult') {
            var place = autocompletebookconsult.getPlace();
        } else if(idval == 'showroom') {
            var place = autocompleteshowroom.getPlace();
        } else if(idval == 'mobilee') {
            var place = autocompletemobilee.getPlace();
        }

        searchStr = await createSearch(place);
        //alert(idval);
        //console.log(searchStr);
        jQuery('.lf-form-'+idval).find("#finalResult-"+idval).val(searchStr);
        jQuery('.lf-form-'+idval).find(".lf-finder-"+idval).click();

      }

      /*********************** MAP ***********************/
    function initMap() {

            var map;
            var bounds = new google.maps.LatLngBounds();
            var mapOptions = {
                mapTypeId: 'roadmap'
            };
                            
            // Display a map on the web page
            map = new google.maps.Map(document.getElementById("mapCanvas"), mapOptions);
            map.setTilt(45);


            // Add multiple markers to map
            var infoWindow = new google.maps.InfoWindow(), marker, i;

            // Loop through our array of markers & place each one on the map
            //alert(markers.length);
            
             //code for mutiple marker
            if(markers.length>1){            
                for( i = 0; i < markers.length; i++ ) {
                //alert(markers[i][1]+'--'+markers[i][2]);

                    var position = new google.maps.LatLng(markers[i][1], markers[i][2]);
                    bounds.extend(position);
                    marker = new google.maps.Marker({
                        position: position,
                        map: map,
                        title: markers[i][0]
                    });
                    
                    // Allow each marker to have an info window    
                    google.maps.event.addListener(marker, 'click', (function(marker, i) {
                        return function() {
                            infoWindow.setContent(infoWindowContent[i][0]);
                            infoWindow.open(map, marker);
                        }
                    })(marker, i));

                    // Automatically center the map fitting all markers on the screen
                    map.fitBounds(bounds);
                }
            }else{
                //code for single marker
                var latlng = new google.maps.LatLng(markers[0][1], markers[0][2]);
                var myOptions = {
                    zoom: 8,
                    center: latlng,
                    mapTypeId: 'roadmap'
                };
                map = new google.maps.Map(document.getElementById("mapCanvas"), myOptions);

                var marker = new google.maps.Marker({
                    position: latlng,
                    map: map,
                    //animation: google.maps.Animation.DROP,
                    title: ""
                });

                marker.setMap(map); 
            }

            // Override our map zoom level once our fitBounds function runs (Make sure it only runs once)
            var boundsListener = google.maps.event.addListener((map), 'bounds_changed', function(event) {
                google.maps.event.removeListener(boundsListener);
            });
    }
